
<!-- new tempalte start -->

<!-- <template>
    <div class="width_100 ">
        <div class="login_bg">

            <div  class="background-column width_100">

                <div class="background-image">
                    <img class="bg_img" width="100%"  src="./../assets/graphic_Side.png" />
                </div>
            </div>


            <div class="width_100">
                <div class="pad_90">
                    <div style="height: 0.5rem;">
                        <v-progress-linear v-show="loading" height="8" indeterminate
                            color="primary"></v-progress-linear>
                    </div>
                    <div>
                        <img width="200px"  src="./../assets/Sustain-Suite-Logo.png" />
                        
                    </div>
                    <div class="mgn-up-30">
                        <div class="stay_connect"> {{ $t("requestPasswordReset.helloText") }}</div>

                        <div class="pb-0">
                            <div>
                                <div cols="12" sm="12" md="12">
                                    <v-alert v-show="error" type="error" transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-alert v-show="success" type="success" transition="scale-transition">
                                        {{success}}
                                    </v-alert>

                                    <v-form @keyup.native.enter="submit">
                                        <v-text-field
                                                autofocus
                                                :label="$t('common.email') + '*'"
                                                name="email"
                                                type="text"
                                                v-model="email"
                                                outlined
                                                :error-messages="emailErrors"
                                                @input="$v.email.$touch()"
                                                @blur="$v.email.$touch()"
                                        ></v-text-field>
                                    </v-form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="py-0">
                            <div>
                                <div >
                                    <v-btn  class="login-button" :disabled="loading"
                                        @click="submit" style="background-color: #022c22 !important;">
                                        {{ $t("requestPasswordReset.go") }}
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        <div class="py-0 mgn-up-30">
                            <a @click="$router.push({name : 'login'})" class="caption">
                                        {{ $t("requestPasswordReset.joinLink") }}
                                    </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> -->


<template>
    <div class="width_100 ">
        <div class="pos_rel">
            <img src="./../assets/Sustain_suite_login_page_image.png"
                lazy-src="./../assets/Sustain_suite_login_page_image.png" class="login_bg" />
            <img class="logo_bg" src="./../assets/sustain-suite-logo-new.png" />
            <div style="height: 0.5rem;">
                <v-progress-linear v-show="loading" height="8" indeterminate color="primary"></v-progress-linear>
            </div>
            <div class="login_card ">
                <div class="w_100 mgn-bt-20">
                    <div>
                        <div class="sign_in">Forget your password</div>
                    </div>
                    <div class="reset_password-Bg">
                        <v-alert v-show="error" type="error" transition="scale-transition">
                            {{ error }}
                        </v-alert>

                        <v-alert v-show="success" type="success" transition="scale-transition">
                            {{ success }}
                        </v-alert>

                        <v-form @keyup.native.enter="submit">
                            <div class="mgn-up-10 pad_20">
                                <div class="reset_txt">Enter your email address to reset your password</div>
                                <!-- :label="$t('common.email') + '*'" -->
                                <v-text-field class="custom_text_field" autofocus 
                                    name="email" type="text" v-model="email" outlined :error-messages="emailErrors"
                                    @input="$v.email.$touch()" @blur="$v.email.$touch()" placeholder="Your email address"></v-text-field>
                            </div>
                        </v-form>
                        <div class="mgn-up-10">
                            <div class="text-left">
                                <v-btn class="login-button" :disabled="loading" @click="submit">
                                    <div class="btn_txt_bg">
                                        <div class="login_txt"> {{ $t("requestPasswordReset.go") }}</div>
                                    </div>
                                </v-btn>
                            </div>
                            <div class="mgn-up-10 text-end login_bg_reset">
                                <div class="login_txt_login">Want to login?</div>
                                <a @click="$router.push({ name: 'login' })" class="caption">
                                    {{ $t("requestPasswordReset.joinLink") }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import {required, email} from 'vuelidate/lib/validators'

    export default {
        name: 'RequestPasswordReset',

        validations: {
            email: {
                required, email
            },
        },

        data: () => ({
            error: null,
            success: null,
            loading: false,

            email: ''
        }),
        computed: {
            emailErrors() {
                const errors = []

                if(!this.$v.email.$dirty) {
                    return errors
                }

                !this.$v.email.required && errors.push(this.$t('common.errors.fieldRequired'))
                !this.$v.email.email && errors.push(this.$t('common.errors.fieldEmailRequired'))
                return errors
            },
        },
        created() {
            const email = this.$route.query.user;

            if(typeof email !== 'undefined') {
                this.email = email;
            }
        },
        methods: {
            submit() {
                this.$v.$touch()
                if(!this.$v.$invalid) {
                    this.loading = true;
                    this.error = null;

                    this.$store.dispatch('requestPasswordReset', {
                        email: this.email
                    }).then(() => {
                        this.$router.push({
                            name: 'requestPasswordResetSuccess',
                            params: {
                                email: this.email
                            }
                        });
                    }).catch((response) => {
                        switch(response.status) {
                            case 404:
                                this.error = this.$t('requestPasswordReset.errors.userNotFound');
                                break;
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

* {
    box-sizing: border-box;
    font-family: 'Inter', sans-serif;
}
.login_bg{
    /* height: 100vh; */
    height: calc(100vh - 15px);
    width: 100vw;
    background: linear-gradient(0deg, #D9D9D9 14.5%, #737373 100%);
    background-blend-mode: multiply;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.logo_bg{
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 250px;
}
.pos_rel{
    position: relative;
}
.pos_abs{
    position: absolute;
}
.login_card{
  
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 1px 2px 0px #00000014;
    border-radius: 8px;
    background: #FFFFFFCC;
    padding: 10px;
    width: -webkit-fill-available;


    display: flex;
    justify-content: center;
    gap: 10px;
}
.sign_in{
    font-size: 24px;
    font-weight: 600;
    line-height: 29.05px;
    padding: 15px;
    text-align: left;
    color: #202020;
}
.form_field_label{
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    text-align: left;
    margin-bottom: 10px;
   
}
 ::v-deep .v-application--is-ltr .v-text-field--outlined fieldset{
    border: 1px solid #DCDCDC !important;
    background: #FFFFFF !important;
    border-radius: 8px !important;
}
::v-deep .form_field_label{
font-size: 14px!important;
font-weight: 500!important;
line-height: 16.94px!important;
text-align: left!important;
}
::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot{
    background: #FFFFFF !important;
}
::v-deep.v-input input{
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 16.94px !important;
    text-align: left !important;
    color: #000000 !important;
}
::v-deep .v-text-field--outlined fieldset{
    border: none !important;
}

.forget_pass_bg{
    text-align: left;
}

.v-application a {
    color: #464646 !important;
    font-weight: 400 !important;
    text-decoration: none !important;
}
.checkbox_reset_bg{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.mgn-up-10{
    margin-top: 10px;
}
.mgn-up-20{
    margin-top: 20px;
}
.pad_5{
padding: 5px;
}
.mgn-bt-20{
    margin-bottom: 20px;
}
.pad_10{
    padding: 10px;
}
.login-button {
    background: linear-gradient(90.45deg, #007B70 8.15%, #B0F122 135.91%);
    width: 25%;
    outline: none;
    border: none;
}
.login_txt{
   
font-size: 12px;
font-weight: 600;
line-height: 16.94px;
text-align: center;
color: #fff;

}
.btn_txt_bg{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}
::v-deep  .checkbox_cls .v-label{
    color: #464646 !important;
    font-weight: 400 !important;
    font-size: 14px !important;
}
.arrow_bg{
    height: 15px;
    width: 15px;
}
::v-deep .v-input--selection-controls{
   margin: 0 !important;
   padding: 0 !important;
}
.w_100{
    width: 100%;
}
.right_sub_card{
    width: 45%;
    margin-right: 15px;
    margin-top: -10px;
    margin-bottom: 30px;
    background: rgb(47 215 7 / 14%)
}
.susuite_txt{font-size: 20px;
    font-weight: 800;
    line-height: 24px;
    text-align: center;
    color: #007B70;
   }

.susuite_txt_subLanel{
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #5a5a5a;
    margin-top: 10px
}
.susuite_txt_subLanel_link{
    font-size: 16px;
    font-weight: 500 !important;
    line-height: 19.2px;
    text-align: center;
    color: #363636 !important;
    border-bottom: 1px solid #363636;
}
.right_pos{
    position: absolute;
    top: 50%;
    /* left: 67%; */
    width: 190px;
    text-align: center;
}
body,html {
    margin: 0;
    padding: 0;
}
.reset_txt{
    font-size: 14px;
    font-weight: 500;
    color: #202020;
    text-align: left;
    margin-bottom: 10px;
}
.login_bg_reset{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5px;
}
.login_txt_login{
    color: #464646 !important;
    font-weight: 400 !important;
    text-decoration: none !important;
}
.reset_password-Bg{
    padding: 5px;
    margin-left: 30px;
    margin-top: -10px;
}
</style>
